import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import { Files } from "../../services/FilesService";
import CustomRTE from "./CustomRTE";

const PublicTextArea = ({ id, label, type, tenantId }) => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    Files.getPublicFileContent("response.html", type, id, tenantId).then(
      (res) => {
        setContent(res.content);
      }
    );
  }, [type, id, tenantId]);

  return content !== null ? (
    <CustomRTE id={id} label={label} defaultValue={content} readOnly />
  ) : (
    <Skeleton height="10rem" />
  );
};
export default PublicTextArea;
